setTimeout(function () {
  console.log("Hello World");
  var products = regproducts;
  var btns = {
    openModal: $('.teeSubs--getStarted--button'),
    continue: $('.teeSubs--continue--button'),
    subscriptionTypeBtn: $('[data-subscription-type]'),
    subscriptionLengthBtn: $('[data-subscription-length]'),
    addToCartBtn: $('[data-add-to-cart]'),
    closeModal: $('.teeSubs--close-modal'),
    nav: $('.teeSubs--modal .menu .number'),
  }

  var vars = {
    body: $('body'),
    modal: $('.teeSubs--modal'),
    radio: $('input[type="radio"]'),
    typeReview: $('.subscription-type-review'),
    lengthReview: $('.subscription-length-review'),
  }

  var resetBtns = function() {
    btns.addToCartBtn.prop('disabled', false);
    btns.continue.prop('disabled', true);
    vars.radio.prop('checked', false);

    $('.order-note--button').prop('disabled', false);
  }

  resetBtns();

  btns.openModal.on('click', function() {
    vars.modal.addClass('in');
    vars.modal.show();
    vars.body.addClass('teeSubs-modal');
  });

  btns.closeModal.on('click', function(e) {
    e.preventDefault();
    vars.modal.removeClass('in');
    vars.modal.addClass('out');
    setTimeout(function() {
      vars.modal.addClass('in');
      vars.modal.removeClass('out');
      vars.modal.hide();
      vars.body.removeClass('teeSubs-modal');
    }, 500);
  });

  vars.radio.on('change', function () {
    const _parent = $(this).parents('.teeSubs--section');
    _parent.find('button').prop('disabled', false);
  });

  btns.subscriptionTypeBtn.on('click', function() {
    subscription.typeValue = $('.teeSubs--subscription-type input[type="radio"]:checked').val();
    subscription.type = $('.teeSubs--subscription-type input[type="radio"]:checked').data('value');
    
    let variants = [];
    $.each(products, function(index, variant) {
      $.each(variant, function(key, item) {
        if (item.availability) {
          if(key in variants) {
            variants[key] += 1;
          } else {
            variants[key] = 1;
          }
        }
      });
    });
  });



  btns.subscriptionLengthBtn.on('click', function() {
    subscription.lengthValue = $('.teeSubs--subscription-length input[type="radio"]:checked').val();
    subscription.length = $('.teeSubs--subscription-length input[type="radio"]:checked').data('value');
  });

  btns.nav.on('click', function() {
    if ($(this).hasClass('selected') || $(this).hasClass('selected')) return false;
    var step = $(this).data('step');
    $('.teeSubs--section').removeClass('show');
    $('.teeSubs--section[data-section="'+step+'"]').addClass('show');
    setNav();
    resetBtns();
  });

  btns.continue.on('click', function() {
    const _parent = $(this).parents('.teeSubs--section');
    let section = _parent.data('section');
    _parent.removeClass('show');
    $('.teeSubs--section[data-section="'+ (++section) +'"]').addClass('show');

    if(subscription.type == 'gift'){
      $('.teeSubs--review').attr('data-section', '4')
      $('.teeSubs--note').attr('data-section', '3')

      $('.review-nav').attr('data-step', '4')
      $('.review-nav').text('4')

      $('.order-note-nav.number').attr('data-step', '3')
      $('.order-note-nav.number').text('3')
      $('.order-note-nav.number').css('display','flex');
      $('.order-note-nav.line').css('display','block');

      $('.gifts-products').show()
      $('.regular-products').hide()
      
    }else {
      $('.gifts-products').hide()
      $('.regular-products').show() 
    }

    if( subscription.type == 'gift' ){
      products = giftproducts;
    }else {
      products = regproducts;
    }

    setNav();
    resetBtns();
    if (section==3) {

      

        if (subscription.length in products) {
            var variant = products[subscription.length]; // Access the product directly
            console.log('Variant assigned:', variant);
          
            // Assign varid and selling_plan even if there are no variants
            subscription.varid = variant["Default Title"].varid;
            subscription.selling_plan = variant["Default Title"].selling_plan;
          
            console.log('subscription.varid:', subscription.varid);
            console.log('Selling Plan:', subscription.selling_plan);
          
            if (variant.availability) {
              btns.addToCartBtn.prop('disabled', false);
            }
          }

      vars.typeReview.text(subscription.typeValue);
      vars.lengthReview.text("Duration: " + subscription.lengthValue);
    }
  });

  function rerenderCartPopup() {
    const popup = document.querySelector('.hs-site-cart-popup-layout');
    if (!popup) return;

    const clone = popup.cloneNode(true);
    popup.parentNode.replaceChild(clone, popup);
  }

  btns.addToCartBtn.on('click', function() {
    console.log('Add to Cart button clicked', subscription);
    var note = $('#note').val();
    if (subscription.varid) {
      var data = {
          id: subscription.varid,
          quantity: 1,
          "selling_plan": subscription.selling_plan,
          properties: {
            "shipping_interval_frequency": 1,
            "shipping_interval_unit_type": "Months" 
          }, 
          attributes: {
            'Subscription Type': subscription.typeValue,
            'note': note
          }
        }
      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify(data)
      };
      fetch('/cart/clear.js')
      .then(function(response) {
        return response.json();
      })
      .then(function() {
        fetch('/cart/add.js', request)
          .then(function(response) {
            return response.json();
          })
          .then(
            function(cart) {
              rerenderCartPopup();         
              var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2];
              var paramDomain = 'myshopify_domain={{ shop.permanent_domain }}';
              try {
                var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
              } catch (err) {
                var paramLinker = '';
              }
              var paramCustomer =
                '{% if customer %}&customer_id={{ customer.id }}&customer_email={{ customer.email }}{% endif %}';
             //window.location = "/cart";

            }
          )
          .catch(
            function() {
              this._showCartError(null);
            }
          );
      })
    }
  });

  var setNav = function() {
    $('.menu .number').removeClass('selected disabled');
    var $sections = $('.teeSubs--section');
    var number = 4;
    $sections.each(function(index) {
      index++;
      if($(this).hasClass('show')) {
        number = index;
        console.log(index)
        if(subscription.type != 'gift' && index == 5){
          index = 4;
        }

        $('.menu .number[data-step="'+index+'"]').addClass('selected');
      } else if(index > number) {
        $('.menu .number[data-step="'+index+'"]').addClass('disabled');
      }
    });
  }

}, 1000);

function monitorFormAction() {
  let currentForm = null;

  const checkForm = () => {
    const form = document.querySelector('form.pf-form-processed');

    if (form && form !== currentForm) {
      currentForm = form;

      // Watch for action attribute changes
      new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.attributeName === "action") {
            const action = form.getAttribute("action");

            if (action === "/checkout") {
            }
          }
        });
      }).observe(form, {
        attributes: true,
        attributeFilter: ["action"],
      });
    }
  };

  // Global observer – keeps watching continuously
  new MutationObserver(checkForm).observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Initial check
  checkForm();
}

monitorFormAction();